import React from 'react';
import ModalCommon from "../../ModalCommon";
import { Row, Col } from "olive-react-myoneui";
import Button from "olive-react-myoneui/lib/Button";

const ModalDelete = ({ title="Do you want to delete?", message, showModalDelete, handleCloseModalDelete, handleSubmitModalDelete,bookmarkData }) => {
    if(!showModalDelete) return null;
    const handleSubmit = async() => {
      await handleSubmitModalDelete(bookmarkData)
    }
    return (
        <ModalCommon
        show={showModalDelete}
        onClose={handleCloseModalDelete}
        title={title}
        className="myk__stu-question-modal"
        >
          <div className="text-start">
            <Row>
              <Col>
                <p>{message}</p>
              </Col>
            </Row>               
            <Row>
              <Col className="text-end mt-3">
                  <Button variant="default" onClick={handleCloseModalDelete}>Cancel</Button>
                  <Button variant="success" onClick={handleSubmit}>Save</Button>
              </Col>
            </Row>
          </div>
        </ModalCommon>
    )
};

export default ModalDelete;
